import OngoingChargingHeader from 'components/ongoingParking/OngoingChargingHeader';
import OngoingChargingStatus from 'components/ongoingParking/OngoingChargingStatus';
import SafeAreaHeaderContainer from 'navigation/SafeAreaHeaderContainer';
import React from 'react';
import { ChargingSession, Maybe } from 'types/generatedSchemaTypes';
import { AnimatedFullContainer } from './styles';

export const OngoingChargingSession: React.FC<{
  session: Maybe<ChargingSession>;
  ongoingChargingSheetExp: boolean;
}> = ({ session, ongoingChargingSheetExp }) => {
  if (!session) {
    return <></>;
  }
  return (
    <AnimatedFullContainer>
      <SafeAreaHeaderContainer
        useInsetForTop={ongoingChargingSheetExp}
        animationDuration={300}>
        <OngoingChargingHeader session={session} />
      </SafeAreaHeaderContainer>
      <OngoingChargingStatus session={session} />
    </AnimatedFullContainer>
  );
};
